// Equipped cosmetic (the player's chosen character face). Pure FRONTEND presentation state,
// persisted to localStorage (mirrors the i18n locale + audio-mute pattern). It NEVER touches the
// wallet, the backend, the sim, or any stat — purely which portrait the player's avatar wears, so
// it's flag-agnostic and PVP-fair (cosmetics are side-grades, never power). Off-DOM it no-ops.

import { portraitSetFor } from './JKGame_assets'

const KEY = 'jkgame.equippedChar'

let equipped: string | null = read()

function read(): string | null {
  try {
    return localStorage.getItem(KEY) || null
  } catch {
    return null // localStorage unavailable
  }
}

/** The owned-character id the player has equipped, or null (the story's built-in avatar). */
export function getEquippedChar(): string | null {
  return equipped
}

export function setEquippedChar(id: string | null): void {
  equipped = id
  try {
    if (id) localStorage.setItem(KEY, id)
    else localStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}

/** Portrait set for the player's avatar: the equipped character's deterministic face (same hash
 *  the gacha reveal already uses, so a pulled character keeps a consistent look), else the
 *  supplied default (the built-in story 'you' set). Cosmetic-only — never affects stats/sim. */
export function playerPortraitSet(defaultSet: string): string {
  return equipped ? portraitSetFor(equipped) : defaultSet
}
